import React from 'react';
import { AppShell, Group, Text, Button, Switch, useMantineColorScheme } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  IconLogout,
  IconSun,
  IconMoon
} from '@tabler/icons-react';

const MemberLayout = ({ children }) => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { colorScheme, toggleColorScheme } = useMantineColorScheme();

  const handleLogout = async () => {
    await logout();
    navigate('/member/login');
  };

  return (
    <AppShell
      header={{ height: { base: 120, sm: 100 } }}
      px={{ base: "sm", sm: 300 }}    // padding left/right
      py={{ base: "sm", sm: "md" }}     // padding top/bottom
    >


      <AppShell.Header p="md">
        {/* Mobile Layout */}
        <div
          style={{
            display: 'block',
            padding: '2px 1px',
            backgroundColor: colorScheme === 'dark' ? 'var(--mantine-color-dark-7)' : 'var(--mantine-color-white)',
          }}
          className="sm:hidden"
        >
          {/* Logo and Title Section MOBILE */}
          <div style={{
            textAlign: 'center',
            marginBottom: '8px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            flexWrap: 'wrap'
          }}>
            <img
              src="/logo512.png"
              width="34px"
              height="34px"
              style={{
                flexShrink: 0,
                borderRadius: '50%',
                border: '1px solid #D4AF37'
              }}
              alt="Aura Cleansing Logo"
            />
            <Text
              size="20px"
              fw={700}
              style={{
                fontFamily: '"Bluu Next", "DM Serif Display", serif',
                // Logic: Deep Wine for Light Mode, Lighter/Brighter Pink-Wine for Dark Mode
                color: colorScheme === 'dark' ? '#E677A1' : '#8B2E5F',
                background: 'none',
                letterSpacing: '0px',
                lineHeight: 1.1,
                textAlign: 'center',
                textShadow: colorScheme === 'dark' ? '0px 2px 4px rgba(0,0,0,0.5)' : 'none'
              }}
            >
              14-Day Aura Cleansing
            </Text>
          </div>

          {/* Controls Section */}
          <Group
            justify="space-between"
            align="center"
            style={{ paddingTop: '4px' }}
          >
            <Switch
              size="md"
              color="pink.8"
              onLabel={<IconSun size={15} stroke={2.5} />}
              offLabel={<IconMoon size={15} stroke={2.5} />}
              checked={colorScheme === 'dark'}
              onChange={() => toggleColorScheme()}
              styles={{
                track: {
                  border: colorScheme === 'dark'
                    ? '2px solid var(--mantine-color-dark-4)'
                    : '2px solid #f3d9fa'
                }
              }}
            />
            <Button
              variant="light"
              color="pink"
              size="sm"
              leftSection={<IconLogout size={16} stroke={2} />}
              onClick={handleLogout}
              styles={{
                root: {
                  color: colorScheme === 'dark' ? '#ffc9c9' : '#9c36b5',
                  fontWeight: 600,
                  borderRadius: '20px',
                }
              }}
            >
              Logout
            </Button>
          </Group>
        </div>

        {/* Desktop Layout */}
        <Group
          h="80px"
          justify="space-between"
          align="center"
          style={{
            display: 'none',
            backgroundColor: colorScheme === 'dark' ? 'var(--mantine-color-dark-7)' : 'var(--mantine-color-white)',
            marginLeft: '40px',
          }}
          className="sm:flex"
        >
          {/* Left side - Logo and Title */}
          <Group align="center" gap="md">
            <img
              src="/logo512.png"
              width="58px"
              height="58px"
              style={{
                borderRadius: '50%',
                border: '2px solid #D4AF37'
              }}
              alt="Aura Cleansing Logo"
            />
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <Text
                size="32px"
                fw={700}
                style={{
                  fontFamily: '"Bluu Next", "DM Serif Display", serif',
                  // Logic: Deep Wine for Light Mode, Lighter/Brighter Pink-Wine for Dark Mode
                  color: colorScheme === 'dark' ? '#E677A1' : '#8B2E5F',
                  background: 'none',
                  lineHeight: 1,
                  filter: colorScheme === 'dark'
                    ? 'drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.5))'
                    : 'none'
                }}
              >
                14-Day Aura Cleansing
              </Text>
              <Text
                size="16px"
                c={colorScheme === 'dark' ? '#ffc9c9' : 'pink.9'}
                style={{ fontFamily: 'Inter, sans-serif', letterSpacing: '1px', textTransform: 'uppercase' }}
              >
                & Chakra Healing Program
              </Text>
            </div>
          </Group>

          {/* Right side - Controls */}
          <Group align="center" gap="lg">
            <Switch
              size="md"
              color="pink.8"
              onLabel={<IconSun size={16} stroke={2.5} />}
              offLabel={<IconMoon size={16} stroke={2.5} />}
              checked={colorScheme === 'dark'}
              onChange={() => toggleColorScheme()}
            />
            <Button
              variant="light"
              color="pink"
              size="md"
              leftSection={<IconLogout size={18} stroke={2} />}
              onClick={handleLogout}
              styles={{
                root: {
                  fontWeight: 600,
                  borderRadius: '20px',
                }
              }}
            >
              Logout
            </Button>
          </Group>
        </Group>
      </AppShell.Header>

      <AppShell.Main>
        {children}
      </AppShell.Main>
    </AppShell>
  );
};

export default MemberLayout;